var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"courseList"},_vm._l((_vm.data),function(item,index){return _c('course-card',{key:index,attrs:{"index":index,"clickId":_vm.clickId,"keyName":("xeslog-" + _vm.CardType + "-click"),"dataExpTag":_vm.dataExpTag,"data":item}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20438b68","hasScoped":false,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/SearchPage/components/CourseList.vue
// module id = 1257
// module chunks = 1